<template>
  <router-link :to="`/view?s=${song.youtubeId}${filterType && filterType !== 'all' ? '&t=' + filterType : ''}`"
    class="song-card" :style="{ backgroundColor: current ? 'var(--color-highlight)' : 'var(--color-surface)' }">
    <img :src="song.thumbnailUrl" />
    <div class="text-wrapper">
      <p class="song-name">{{ song.displayName[$i18n.locale.slice(0, 2)] || song.displayName.ja }}</p>
      <p class="song-description">{{ $t(song.type + 'Song') }} - {{ song.releaseAt || new
        Date(song.publishedAt).toLocaleDateString() }}
      </p>
      <div class="singer-tag">
        <span v-for="singer in resolvedSingers" :key="singer.name" class="singer-name"
          :style="{ backgroundColor: singer.color }">{{ singer.name }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
import config from '../assets/data/songs.js'

export default {
  name: 'VideoListCard',
  props: {
    song: {
      type: Object,
      required: true
    },
    current: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      config: config
    }
  },
  computed: {
    resolvedSingers() {
      if (!this.song || !this.song.singers) return [];
      const lang = this.$i18n.locale.slice(0, 2);
      return this.song.singers.map(id => {
        const singer = this.config.singers.find(s => s.id === id);
        if (singer) {
          return { name: singer[lang] || singer.ja || id, color: singer.color || '', channelUrl: singer.channelUrl || '' };
        }
        return { name: id, color: '', channelUrl: '' };
      });
    },
  }
}
</script>

<style scoped>
.song-card {
  background-color: var(--color-surface);
  text-decoration: none;
  width: 100%;
  height: 100px;
  color: var(--color-text-primary);
  transition: transform 0.1s, box-shadow 0.1s, border 0.1s;
  /* box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 0px var(--color-primary); */
  display: flex;
  border: 0px solid var(--color-primary);
  border-top: 1px solid var(--color-highlight);
}

.song-card img {
  width: calc(75px * 16/9);
  height: 75px;
  object-fit: cover;
  margin: auto 0 auto 4px;
}

.song-card:hover {
  transform: translateX(-6px);
  /* box-shadow: 0 2px 4px var(--color-shadow), inset 0 0 0 1px var(--color-primary); */
  border: 1px solid var(--color-primary);
}

.text-wrapper {
  margin: auto auto auto 0px;
  min-width: 0;
  flex: 1;
}

.song-name {
  font-size: 1.1rem;
  font-weight: 400;
  margin: 0 0 0 1.0rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.song-description {
  font-size: 0.8rem;
  margin: 0rem 0 0 1.0rem;
  color: var(--color-text-secondary);
}

.singer-tag {
  display: flex;
  gap: 4px;
  margin: 4px 0.5rem 0 1.0rem;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
}

.singer-tag::-webkit-scrollbar {
  display: none;
}

.singer-name {
  display: inline-block;
  color: var(--color-on-secondary);
  padding: 0px 4px 2px 4px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 300;
  text-wrap-mode: nowrap;
}

@media (max-width: 600px) {
  .song-card {
    box-shadow: none;
  }

  .song-card:hover {
    transform: none;
    box-shadow: none;
  }

  .song-name {
    font-size: 1.05rem;
  }

}
</style>
